// import styled from "styled-components";
// import React, { createContext, useContext, useEffect, useState } from "react";

import {
  Landmark,
  Text,
  CircleCheckBig,
  Split,
  ListChecks,
  Paperclip,
  TextSearch,
} from "lucide-react";
import { ContractHeader, Detail } from "./ContractDetails";
import { toPascalCase } from "../../utils/helpers";
import { FaGavel } from "react-icons/fa";
import { Separator } from "../../components/ui/separator";
import { ContractContext } from "./ContractDescription";
import { useContext } from "react";
import { sbirAgency } from "../search/SbirFilters";
import { Attachments } from "./Attachments";
import { Recommendations } from "./Recommendations";

export default function SbirContract({ contract }) {
  const {
    description = null,
    phase = null,
    program = null,
    agency = null,
    branch = null,
    closeDate = null,
    releaseDate = null,
    openDate = null,
    status = null,
    solicitationAgencyURL = null,
  } = contract || {};

  const { isLoading } = useContext(ContractContext);

  const headerData = [
    {
      title: "Buyer",
      icon: Landmark,
      details: [sbirAgency.find((a) => a.keys.includes(agency))?.label],
    },

    { title: "Status", icon: CircleCheckBig, details: [toPascalCase(status)] },

    { title: "Phase", icon: ListChecks, details: [phase] },
    { title: "Program", icon: FaGavel, details: [program] },
    { title: "Branch", icon: Split, details: [toPascalCase(branch)] },
  ];

  const timelineData = [
    {
      title: "Release Date",
      date: releaseDate,
    },
    {
      title: "Open Date",
      date: openDate,
    },

    {
      title: "Due Date",
      date: closeDate,
    },
  ];

  return (
    <dl>
      <div id="contract-details" className="flex flex-col gap-4 py-4 ">
        <ContractHeader headerData={headerData} timelineData={timelineData} />

        <Separator />
        <div id="contract-description">
          <Detail title="Description" icon={Text} details={[description]} />
        </div>
        <Separator />
        <Detail
          title="Attachments"
          icon={Paperclip}
          details={[
            <Attachments
              attachments={[
                {
                  type: "link",
                  name: "Topic Link",
                  link: solicitationAgencyURL,
                },
              ]}
              searchType="sbir"
              isLoading={isLoading}
            />,
          ]}
        />
        <Separator />

        <Detail
          title={"Similar Active Opportunities"}
          icon={TextSearch}
          details={[
            <Recommendations searchType="sbir" description={description} />,
          ]}
        />
      </div>
    </dl>
  );
}
